import { Provider } from '@angular/core';
import { OPERATORS } from 'src/app/services/constants';
import { ToolbarControlDescriptor, TOOLBAR_CONTROLS } from '../../shared/contracts/toolbar-control.tokens';
import { VfSearchControlComponent } from './controls/toolbar-search-controls';
import { VfPortCallControlComponent } from './controls/toolbar-port-call-controls';
import { VfExpectedArrivalsControlComponent } from './controls/toolbar-expected-arrivals-controls';
import { VfWatchedVesselsControlComponent } from './controls/toolbar-vessel-controls';

/**
 * VesselFinder's toolbar controls — FOUR descriptors: search (name/MMSI/IMO
 * lookup, same UI shape as Voyage Radar's search drawer), the standing
 * port-calls drawer, the standing Expected Arrivals drawer (search by port
 * LOCODE within a time window), and the standing "Watched Vessels" drawer
 * (mirrors Voyage Radar's `VesselHistoryControlComponent` — every hull
 * located or saved this session, with center/remove per row).
 *
 * `operatorKey` is stamped by the `.map()` below, never written per
 * descriptor — ownership is a property of the file (NEW-AIS-WIZARD.md Part
 * 3.3), so it cannot be forgotten on a future entry.
 */
const VF_DESCRIPTORS: ToolbarControlDescriptor[] = [
  { id: 'vf-search', component: VfSearchControlComponent, slots: ['live'], defaultOrder: 5, requires: ['vessel-search', 'priced-actions'] },
  { id: 'vf-port-call', component: VfPortCallControlComponent, slots: ['live'], defaultOrder: 22, requires: ['priced-actions'] },
  // After Port Calls (22), before Watched Vessels (35).
  { id: 'vf-expected-arrivals', component: VfExpectedArrivalsControlComponent, slots: ['live'], defaultOrder: 28, requires: ['priced-actions'] },
  { id: 'vf-watched-vessels', component: VfWatchedVesselsControlComponent, slots: ['live'], defaultOrder: 35, requires: ['vessel-search'] },
];

/** The string the host matches this file's `operatorKey` and `VESSELFINDER_CONFIG.operatorKey` against — derived, never restated. */
export const VF_OPERATOR_KEY = OPERATORS.VESSELFINDER;

export const VF_TOOLBAR_CONTROL_PROVIDERS: Provider[] = VF_DESCRIPTORS.map((d) => ({
  provide: TOOLBAR_CONTROLS,
  useValue: { ...d, operatorKey: VF_OPERATOR_KEY },
  multi: true,
}));
